import { styled } from "styled-components";

export const InstructorsItemWrapper = styled.div`
  padding: 60px 0;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0;
  }
`;

export const InstructorsItemWrap = styled.div`
  .title-wrap {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 80px;
    h3 {
      font-family: "AnekLatin-semibold";
      font-size: 72px;
      line-height: 72px;
      color: #171717;
    }
    p {
      color: #242424;
      font-size: 24px;
      line-height: 32px;
    }
  }
  @media all and (max-width: 768px) {
    .title-wrap {
      gap: 3.333vw;
      margin-bottom: 8.889vw;
      h3 {
        font-size: 8vw;
        line-height: 1;
      }
      p {
        font-size: 3.556vw;
        line-height: 1.3;
      }
    }
  }
`;

export const InstructorsItemListWrap = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  @media all and (max-width: 640px) {
    gap: 4.444vw;
  }
`;

export const InstructorsItem = styled.li`
  width: calc(33.333% - 40px / 3);

  &:nth-child(3n) {
    margin-right: 0;
  }
  .img-area {
    transition: all 0.3s ease;
    position: relative;
    &:hover {
      .img-sub-text {
        opacity: 1;
        visibility: visible;
      }
      .img-area-dim {
        opacity: 1;
        visibility: visible;
      }
      & + .text-wrap {
        display: none;
      }
    }
    .img-area-dim {
      transition: all 0.3s ease;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 500px;
      background-color: rgba(0, 0, 0, 0.6);
      opacity: 0;
      visibility: hidden;
    }
    .img-sub-text {
      opacity: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fbfbfb;
      font-size: 36px;
      line-height: 1.3;
      font-weight: bold;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
    }
  }
  a {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  img {
    width: 100%;
    height: 500px;
  }
  .text-wrap {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    text-align: center;
    margin-bottom: 20px;
    transition: all 0.2s linear;
    h6 {
      font-weight: 700;
      font-size: 32px;
      line-height: 1.4;
      color: #242424;
    }
    p {
      font-size: 20px;
      line-height: 1.4;
      color: #6f6f6f;
    }
  }
  @media all and (max-width: 1024px) {
    width: calc(50% - 10px);
    margin-right: 0;
  }
  @media all and (max-width: 900px) {
    .img-area {
      .img-area-dim {
        height: 55.556vw;
      }
      img {
        height: 55.556vw;
      }
      .img-sub-text {
        font-size: 30px;
      }
    }
    .text-wrap {
      margin-bottom: 0;
      gap: 6px;
      h6 {
        font-size: 26px;
      }
      p {
        font-size: 16px;
      }
    }
  }
  @media all and (max-width: 640px) {
    width: 100%;
    margin-right: 0 !important;
    a {
      gap: 2.222vw;
    }
    .img-area {
      &:hover {
        & + .text-wrap {
          display: flex;
        }
      }
      img {
        height: auto;
      }
      .img-area-dim {
        display: none;
      }
    }
    .img-sub-text {
      display: none;
    }
    .text-wrap {
      gap: 0.667vw;
      h6 {
        font-size: 3.556vw;
      }
      p {
        font-size: 2.889vw;
      }
    }
  }
`;
